import pascalize from './pascalize';
/**
 * @param {Object} styles - css module styles
 * @param {string|string[]|Object} prop - The string value of a prop or responsive array of the props, or an object with responsive keys
 * @param {string} prop[0] - Value at xs screen-size and up
 * @param {string} prop[1] - Value at sm screen-size and up
 * @param {string} prop[2] - Value at md screen-size and up
 * @param {string} prop[3] - Value at lg screen-size and up
 * @param {string} prop[4] - Value at xl screen-size and up
 * @param {Object} prop - An object with responsive arrays
 * @param {string} prop.xs - Value at xs screen-size and up
 * @param {string} prop.sm - Value at sm screen-size and up
 * @param {string} prop.md - Value at md screen-size and up
 * @param {string} prop.lg - Value at lg screen-size and up
 * @param {string} prop.xl - Value at xl screen-size and up
 * @param {string} propName - The name of the prop
 * @returns An array with camelized style string values
 *
 * @example
 * makeResponsive(styles, 'space-around', 'justifyContent')
 * makeResponsive(styles, { sm: 'space-between', md: 'space-around' }, 'justifyContent')
 * makeResponsive(styles, [ undefined, 'space-between', 'space-around' ], 'justifyContent')
 */

var makeResponsive = function makeResponsive(styles, prop, propName) {
  // xSmall, small, medium, large, xLarge
  var prefix = pascalize(propName);

  if (typeof prop === 'string') {
    var _ref;

    return _ref = {}, _ref[styles["" + propName + pascalize(prop)]] = !!prop, _ref;
  }

  if (Array.isArray(prop)) {
    var _ref2;

    return _ref2 = {}, _ref2[styles["" + propName + pascalize(prop[0])]] = !!prop[0], _ref2[styles["sm" + prefix + pascalize(prop[1])]] = !!prop[1], _ref2[styles["md" + prefix + pascalize(prop[2])]] = !!prop[2], _ref2[styles["lg" + prefix + pascalize(prop[3])]] = !!prop[3], _ref2[styles["xl" + prefix + pascalize(prop[4])]] = !!prop[4], _ref2;
  }

  if (typeof prop === 'object') {
    var _ref3;

    return _ref3 = {}, _ref3[styles["" + propName + pascalize(prop.xs)]] = !!prop.xs, _ref3[styles["sm" + prefix + pascalize(prop.sm)]] = !!prop.sm, _ref3[styles["md" + prefix + pascalize(prop.md)]] = !!prop.md, _ref3[styles["lg" + prefix + pascalize(prop.lg)]] = !!prop.lg, _ref3[styles["xl" + prefix + pascalize(prop.xl)]] = !!prop.xl, _ref3;
  }

  return {};
};

export default makeResponsive;